import { updateJoyrideConfig } from '../services/onboarding';

import { useMutation } from '@tanstack/react-query';

export const useUpdateJoyrideConfig = () => {
  return useMutation({
    mutationFn: (data) => updateJoyrideConfig(data),
  });
};
